export const timeToDateString = (time) => {
  return `${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()} ${time}:00`
};